module.exports = __webpack_public_path__ + "img/palyackin.4d322092.jpg";